<template>
  <div>
    <vue-good-table
      :rows="newsletters"
      :columns="tableColumns"
      @on-row-click="({row}) => click(row)"
      styleClass="vgt-table"
    >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'subject'">
          {{ value(props.row).subject || 'Untitled' }}
        </span>
        <span v-else-if="props.column.field == 'type'">
          <span
            v-if="value(props.row).newsletterType"
            :style="`color: ${value(props.row).newsletterType.color}`"
          >
            <icon
              :icon="value(props.row).newsletterType.icon"
              class="mr-1"
            />
          </span>
          {{ value(props.row).newsletterType ? value(props.row).newsletterType.name : null }}
        </span>
        <span v-else-if="props.column.field == 'createdBy'">
          {{ props.row.originalUser ? `${props.row.originalUser.firstName} ${props.row.originalUser.lastName}` : `${props.row.publisher.firstName} ${props.row.publisher.lastName}` }}
        </span>
        <span v-else-if="props.column.field == 'lastUpdated'">
          <span
            v-if="value(props.row).updatedAt"
            v-date="{ date: value(props.row).updatedAt, format: $settings.dateTimeFormat, isIso: true }"
          />
        </span>
        <span v-else-if="props.column.field == 'publishedAt'">
          <span
            v-if="value(props.row).publishedAt || value(props.row).updatedAt"
            v-date="{ date: value(props.row).publishedAt || value(props.row).updatedAt, format: $settings.dateTimeFormat, isIso: true }"
          />
        </span>
        <span v-else-if="props.column.field == 'menu'">
          <dropdown
            class="no-chev"
            placement="bottom"
            alignment="right"
            trigger="click"
            popper-class="table-popover"
            @click.native.stop
          >

            <template slot="trigger">
              <icon icon="more-vertical" />
            </template>


            <dropdown-option
                v-if="($login.can('newsletters.view') || $login.can('newsletters.view.mine')) && (props.row._id === null || props.row._id === undefined)"
                :href="$router.resolve({ name: 'newsletters.view', params: { newsletterId: value(props.row).id } }).href"
                class="text-gray-600"
                style="text-decoration: none;margin: 0 3px"
            >
                <icon icon="preview" />
                View
            </dropdown-option>
            <dropdown-option
                :href="$router.resolve({ name: 'newsletters.draft', params: { draftId: props.row._id } }).href"
                class="text-gray-600"
                style="text-decoration: none;margin: 0 3px"
                v-if="($login.can('newsletter-drafts.update') || $login.can('newsletter-drafts.update.mine')) && (props.row._id !== null && props.row._id !== undefined)"
            >
                <icon icon="edit" />
                Edit
            </dropdown-option>
            <dropdown-option
                v-if="$login.can('alerts.view') && value(props.row).deletedAt === null"
                class="text-gray-600"
                style="text-decoration: none;margin: 0 3px"
                href="javascript:;"
                @click.native="$emit('show-alerts', value(props.row).id)"
            >
              <icon icon="alerts" />
              Alerts
            </dropdown-option>
            <dropdown-option
                v-if="($login.can('newsletters.delete') || $login.can('newsletters.delete.mine')) && (value(props.row).deletedAt === undefined || value(props.row).deletedAt === null)"
                class="text-gray-600"
                style="text-decoration: none;margin: 0 3px"
                href="javascript:;"
                @click.native="$emit('delete', props.row)"
            >
              <icon icon="delete" />
              Delete
            </dropdown-option>
            <dropdown-option
              v-if="($login.can('newsletters.delete') || $login.can('newsletters.delete.mine')) && value(props.row).deletedAt !== undefined && value(props.row).deletedAt !== null"
              class="text-gray-600"
              style="text-decoration: none;margin: 0 3px"
              href="javascript:;"
              @click.native="restore(props.row)"
            >
              <i class="sl-arrow-up-circle" />
              Restore
            </dropdown-option>
          </dropdown>


        </span>
      </template>
    </vue-good-table>
    <pagination
      :data="pagination"
      :disabled="loading"
      @change-page="(p) => $emit('change-page', p)"
    />
  </div>
</template>

<script>
import {VueGoodTable} from 'vue-good-table'
import Pagination from '@/components/Pagination'
import Date from '@/directives/date'
import Dropdown from '@/components/Dropdown/Dropdown'
import DropdownOption from '@/components/Dropdown/DropdownOption'

export default {
  directives: {
    Date,
  },
  components: {
    Pagination,
    Dropdown,
    DropdownOption,
    VueGoodTable,
  },
  props: {
    value: {
      required: false,
      type: Function,
      default (v) {
        return v
      },
    },
    newsletters: {
      type: Array,
      required: true,
    },
    pagination: {
      type: Object,
      required: false,
      default: null,
    },
    isDraftsList: {
      type: Boolean,
      default: false,
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tableColumns: [
        {
          label: 'Subject',
          field: 'subject',
        },
        {
          label: 'Type',
          field: 'type',
          width: '200px',
        },
        {
          label: 'Created By',
          field: 'createdBy',
          width: '200px',
        },
        {
          label: this.isDraftsList ? 'Last Updated At' : 'Published At',
          field: this.isDraftsList ? 'lastUpdated' : 'publishedAt',
          width: '200px',
        },
        {
          label: '',
          field: 'menu',
          width: '48px',
        },
      ]
    }
  },
  methods: {
    click (row) {
      if (row.originalUserId) {
        this.$router.push({
          name: 'newsletters.draft',
          params: {
            draftId: row._id,
          },
        })
      } else {
        this.$router.push({
          name: 'newsletters.view',
          params: {
            newsletterId: row._id,
          },
        })
      }
    },
  },
}
</script>
